export default __webpack_public_path__ + "static/media/messageInfo64.7046f206.svg";